<template>
  <div id="app">
		<keep-alive exclude='Home,Staff,Balance,Profile'>
			<router-view></router-view>
		</keep-alive>
<!--    <router-view></router-view>-->
	</div>
</template>


<script>

export default {
  name: 'app',
  components: {},
	created: function(){
		// 读取会话存储保存Store
		if (sessionStorage.getItem('store')){
			this.$store.replaceState(
				Object.assign(
					{},
					this.$store.state,
					JSON.parse(sessionStorage.getItem('store'))
				)
			)
		}
		// 监听刷新、再次存储Store
		window.addEventListener('beforeunload', () => {
			sessionStorage.setItem('store', JSON.stringify(this.$store.state))
		})
	},
	mounted: function(){
	
	},
}
</script>

<style lang="scss">
body{ font-family: "Microsoft YaHei", 微软雅黑, "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", Arial, sans-serif !important; }
.container{ min-height: 100vh !important;}
.ant-layout-content{ width: calc(100vw - 200px) !important; min-width: 1260px; padding: 0 16px;}
.ant-btn{
	height: 48px !important;
	font-size: 16px !important;
	.anticon{
		padding: 0 6px;
		font-size: 16px;
	}
}
.ant-btn-sm{ height: 32px !important; line-height: 32px !important; font-size: 14px !important;}
.ant-input{ height: 48px !important; line-height: 48px !important; font-size: 16px !important;}
.ant-calendar-range-picker-input{ height: 46px !important;}
.ant-calendar-picker-input.ant-input{ padding: 0; line-height: 46px !important;}
// .ant-btn-group > .ant-btn:first-child:not(:last-child){ border-right: 0;}
</style>
